"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./index'));



//////////////////
// WEBPACK FOOTER
// ./~/ng2-charts/ng2-charts.js
// module id = 447
// module chunks = 7